import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
interface BusPickupAllocationIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}
const BusPickupAllocation: React.FC<BusPickupAllocationIconProps> = ({
  color,
  ...props
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.39095 13.8441C6.11369 14.1518 5.6391 14.1761 5.33138 13.8988C5.02364 13.6216 4.99846 13.147 5.27572 12.8393L6.39095 13.8441ZM5.33822 12.7758C5.61989 12.5204 6.05553 12.5148 6.34408 12.7748C6.6518 13.0521 6.67601 13.5266 6.39876 13.8344L6.39095 13.8441L5.27572 12.8393L5.28451 12.8305L5.33822 12.7758Z"
      fill={color}
    />
    <path
      d="M1.75 15.833V9L1.75391 8.92285C1.79253 8.54488 2.11183 8.25 2.5 8.25H17.5C17.9142 8.25 18.25 8.58579 18.25 9C18.25 9.41421 17.9142 9.75 17.5 9.75H3.25V15.833C3.25 15.8789 3.28713 15.9168 3.33301 15.917H17.083L17.1602 15.9209C17.5383 15.9594 17.833 16.2787 17.833 16.667C17.8328 17.0551 17.5382 17.3746 17.1602 17.4131L17.083 17.417H3.33301C2.45872 17.4168 1.75 16.7074 1.75 15.833Z"
      fill={color}
    />
    <path
      d="M14.167 0.916992C16.4219 0.917168 18.2498 2.74509 18.25 5V6.66699C18.2498 7.08106 17.9141 7.41699 17.5 7.41699C17.0859 7.41699 16.7502 7.08106 16.75 6.66699V5C16.7498 3.57353 15.5934 2.41717 14.167 2.41699H5.83301C4.40653 2.41717 3.25018 3.57352 3.25 5V6.66699C3.24982 7.08106 2.9141 7.41699 2.5 7.41699C2.0859 7.41699 1.75018 7.08106 1.75 6.66699V5C1.75018 2.74509 3.5781 0.917168 5.83301 0.916992H14.167Z"
      fill={color}
    />
    <path
      d="M14.1664 5.91667L14.2435 5.92057C14.6216 5.95905 14.9164 6.27839 14.9164 6.66667C14.9164 7.05494 14.6216 7.37429 14.2435 7.41276L14.1664 7.41667H5.83334C5.41913 7.41667 5.08334 7.08088 5.08334 6.66667C5.08334 6.25245 5.41913 5.91667 5.83334 5.91667H14.1664Z"
      fill={color}
    />
    <path
      d="M3.33334 16.6667H6.66668V18.3333C6.66668 18.7936 6.29358 19.1667 5.83334 19.1667H4.16668C3.70644 19.1667 3.33334 18.7936 3.33334 18.3333V16.6667Z"
      fill={color}
    />
    <g clip-path="url(#clip0_667_49289)">
      <path
        d="M17.5844 14.8094C17.5281 14.8094 17.4719 14.7906 17.4344 14.7437L14.6125 11.9219L14.5937 14.1719C14.5937 14.2844 14.5 14.3875 14.3781 14.3781C14.2656 14.3781 14.1719 14.2844 14.1719 14.1625L14.2 11.4062C14.2 11.2937 14.2938 11.2 14.4063 11.2L17.1719 11.1719C17.2844 11.1719 17.3781 11.2656 17.3781 11.3781C17.3781 11.4906 17.2844 11.5938 17.1719 11.5938L14.9031 11.6125L17.7344 14.4437C17.8187 14.5281 17.8187 14.6594 17.7344 14.7437C17.6969 14.7812 17.6406 14.8094 17.5844 14.8094Z"
        fill={color}
      />
      <path
        d="M17.3779 11.3779C17.3778 11.2655 17.2843 11.1719 17.1719 11.1719L14.4062 11.2002L14.3652 11.2041C14.2718 11.2235 14.2002 11.3078 14.2002 11.4063L14.1719 14.1621C14.1719 14.2839 14.2655 14.3778 14.3779 14.3779C14.4844 14.3861 14.5701 14.3087 14.5898 14.2139L14.5937 14.1719L14.6123 11.9219L17.4346 14.7441C17.4628 14.7792 17.5016 14.7983 17.543 14.8057L17.584 14.8096C17.6119 14.8096 17.6404 14.8026 17.666 14.791L17.7344 14.7441C17.8082 14.6703 17.8171 14.5603 17.7617 14.4775L17.7344 14.4434L14.9033 11.6123L17.1719 11.5938C17.2702 11.5938 17.3545 11.5149 17.374 11.4199L17.3779 11.3779ZM17.6777 11.3779C17.6777 11.6381 17.4679 11.8915 17.1738 11.8926L17.1748 11.8936L15.6211 11.9063L17.9463 14.2314L18.0127 14.3125C18.1259 14.4832 18.1259 14.7043 18.0127 14.875L17.9463 14.9561C17.8633 15.0389 17.7338 15.1094 17.584 15.1094C17.4725 15.1093 17.3305 15.073 17.2227 14.9561L14.9053 12.6387L14.8936 14.1748C14.892 14.4318 14.6827 14.6862 14.3779 14.6758L14.3779 14.6777C14.3737 14.6777 14.3695 14.6759 14.3652 14.6758C14.362 14.6756 14.3587 14.677 14.3555 14.6768L14.3555 14.6748C14.0799 14.6627 13.8721 14.4335 13.8721 14.1621L13.8721 14.1592L13.9004 11.4033C13.902 11.1274 14.1274 10.903 14.4033 10.9014L17.1689 10.8721L17.1719 10.8721L17.2734 10.8818C17.5035 10.9292 17.6776 11.1346 17.6777 11.3779Z"
        fill={color}
      />
    </g>
    <path
      d="M13.3333 16.6667H16.6667V18.3333C16.6667 18.7936 16.2936 19.1667 15.8333 19.1667H14.1667C13.7064 19.1667 13.3333 18.7936 13.3333 18.3333V16.6667Z"
      fill={color}
    />
    <defs>
      <clipPath id="clip0_667_49289">
        <rect width="6" height="6" fill="white" transform="translate(13 10)" />
      </clipPath>
    </defs>
  </svg>
);
export default BusPickupAllocation;
